import { useEffect } from 'react';
import { Icon } from '@/components/ui/icon';
import { cn } from '@/lib/core';

interface BannerSheetProps {
  open: boolean;
  onClose: () => void;
  message: string;
  palette?: 'light' | 'dark';
  duration?: number;
}

export function BannerSheet({
  open,
  onClose,
  message,
  palette = 'light',
  duration = 3000,
}: BannerSheetProps) {
  useEffect(() => {
    if (!open || duration === 0) return;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [open, duration, onClose]);

  if (!open) return null;

  const isDark = palette === 'dark';

  return (
    <div
      className={cn(
        'fixed inset-x-0 bottom-0 z-99999 flex items-center gap-2 px-4 py-6.5',
        isDark ? 'bg-jncquoi-neutral-1000' : 'bg-white'
      )}
    >
      <Icon
        name="check-circle-solid"
        width={16}
        height={16}
        className={cn('shrink-0', isDark ? 'text-white' : 'text-jncquoi-neutral-1000')}
      />
      <p
        className={cn(
          'font-pp-neue-montreal text-[14px] tracking-[0.5px]',
          isDark ? 'text-white' : 'text-jncquoi-neutral-1000'
        )}
      >
        {message}
      </p>
    </div>
  );
}
